import { UIGameHowToWinFloatingVPView } from './UIGameHowToWinFloatingVPView.ts';
import { UIGameFloatingVictoryPointsView } from './UIGameFloatingVictoryPointsView.ts';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
import { TileCornerBonusType, TileCornerBuildingType, TurnState } from '@colonist/game-states';
export class UIGameFloatingVictoryPointsController {
    createFloatingVPForCorner(corner, previousBuildingType) {
        if (!this.showFloatingVPForCorner(corner)) return;
        const mapView = this.uiGameManager.mapController.mapView;
        const floatingVPWidth = this.itemSizeScaled * 0.8;
        const floatingVPHeight = this.itemSizeScaled * 0.4;
        const text = this.calculateVPChangeText(corner, previousBuildingType);
        const vpChangeText = {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: text
            }
        };
        const point = corner.hexCorner.toPixel(mapView.mapCenter, mapView.hexagonHeight / 2);
        const x = point.x - floatingVPWidth / 2;
        const y = point.y - this.itemSizeScaled * 0.65;
        const vpView = new UIGameFloatingVictoryPointsView(this.uiGameManager, x, y, floatingVPWidth, floatingVPHeight, mapView, vpChangeText);
        const distanceY = this.itemSizeScaled / 10;
        const velocityY = 0.1;
        const fadeSpeed = 0.1;
        vpView.setVerticalAnimation(distanceY, velocityY, fadeSpeed);
    }
    // eslint-disable-next-line class-methods-use-this
    showFloatingVPForCorner(corner) {
        switch(corner.buildingType){
            case TileCornerBuildingType.Settlement:
            case TileCornerBuildingType.City:
            case TileCornerBuildingType.DestroyedCity:
                return true;
            default:
                return false;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    calculateVPChangeText(corner, previousBuildingType) {
        if (corner.buildingType == undefined) return '';
        const wasCityDowngraded = previousBuildingType == TileCornerBuildingType.City && (corner.buildingType == TileCornerBuildingType.DestroyedCity || corner.buildingType == TileCornerBuildingType.Settlement);
        if (wasCityDowngraded) return '-1';
        if (corner.hasCornerBonusOfType(TileCornerBonusType.IslandSettlingChits) && previousBuildingType == undefined) return '+3';
        const amountToDeduct = previousBuildingType == TileCornerBuildingType.Settlement || previousBuildingType == TileCornerBuildingType.DestroyedCity ? 1 : 0;
        const vpChange = corner.buildingType - amountToDeduct;
        if (vpChange < 0) return `${vpChange}`;
        return `+${vpChange}`;
    }
    hideHowToWinFloatingVPView() {
        if (this.howToWinFloatingVPView == undefined) return;
        this.howToWinFloatingVPView.visible = false;
    }
    constructor(uiGameManager){
        this.uiGameManager = uiGameManager;
        const isUserOnMobile = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI && !UIUtilsEjsVariables.isUserOnTabletApp;
        const itemScale = isUserOnMobile ? 2 : 1;
        const itemSize = this.uiGameManager.canvasController.itemSize;
        this.itemSizeScaled = itemSize * itemScale;
        if (uiGameManager.gameController.currentState.turnState != TurnState.InitialPlacement) return;
        if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return;
        if (uiGameManager.gameController.isReplay) return;
        this.howToWinFloatingVPView = new UIGameHowToWinFloatingVPView(this.uiGameManager);
    }
}
